import React,{useState, useEffect} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import {
    oldTimeZoneMapper,
    handleBlankValue,
    handleBlankValueForScheduledDeliveryEnd,
    convertLocaleTimeToFormat,
    handlePackageStateMapping,
    handlePackageReasonMapping,
    getFeatureStatus
} from "../../../commons/CommonUtils";
import { FormattedMessage } from "react-intl";
import Textarea from "@amzn/meridian/textarea";
import Button from "@amzn/meridian/button";
import {getAPIGatewayDataFromParent} from "../../../handler/ParentDataHandler";
import {logOperationalMetric, isINRegion, getServiceType} from "../../../util/CommonUtils";
import { FEATURES } from "../../../commons/constants/CommonConstants";


const ShipmentInfo = (props) => {

    const [inputNote, setInputNote] = useState("");
    const [isInternalPDDEnabled, setIsInternalPDDEnabled] = useState(false);
    const metricProcessName = "SHIPMENTINFO_NOTES";

    useEffect(() => {
        const checkFeatureFlag = async () => {
            const isEnabled = await getFeatureStatus(FEATURES.IS_PACKAGE_SEARCH_INTERNAL_PDD_ENABLED);
            setIsInternalPDDEnabled(isEnabled);
        };
        checkFeatureFlag();
    }, []);

    if (!props.data) {
        return null;
    }
    let dateOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: props.data.stationTimeZone? oldTimeZoneMapper(props.data.stationTimeZone) : undefined
    };
    let dateOptionsWithTime = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: props.data.stationTimeZone? oldTimeZoneMapper(props.data.stationTimeZone) : undefined
    };
    let cycleInfo = props.data.cycleInfo ? props.data.cycleInfo : {};
    let routeInfo = props.data.routeInfo ? props.data.routeInfo : {};
    let shipInfo = props.data.shipInfo ? props.data.shipInfo : {};
    let customerNotes = props.data.customerNotes ? props.data.customerNotes : [];
    let lockerName = props.data.lockerName ? props.data.lockerName : '';
    let itemDescription = shipInfo.itemDescription ? shipInfo.itemDescription : "";
    let serviceType = getServiceType(props.data.serviceType);

    let dateTimeOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: props.data.stationTimeZone? oldTimeZoneMapper(props.data.stationTimeZone) : undefined
    };

    let shipDate = shipInfo.shipDate ? new Date(shipInfo.shipDate)
        .toLocaleString("en-US", dateTimeOptions) : "";
    let lastUpdatedTime = props.data.lastUpdatedTime ? new Date(props.data.lastUpdatedTime)
        .toLocaleString("en-US", dateTimeOptions) : "";
    let promisedDeliveryDate = shipInfo.promisedDeliveryTime ? new Date(shipInfo.promisedDeliveryTime)
        .toLocaleString("en-US", dateOptions) : "";
    let internalPromisedDeliveryDate = shipInfo.internalPromisedDeliveryTime ? new Date(shipInfo.internalPromisedDeliveryTime)
        .toLocaleString("en-US", dateOptions) : "";
    let estimatedArrivalDate = shipInfo.estimatedArrivalTime ? new Date(shipInfo.estimatedArrivalTime)
        .toLocaleString("en-US", dateOptions) : "";   
    let scheduledDeliveryTime = shipInfo.scheduledDeliveryTime ? new Date(shipInfo.scheduledDeliveryTime)
        .toLocaleString("en-US", dateOptionsWithTime) : "";
    let scheduledDeliveryTimeEnd = shipInfo.scheduledDeliveryTimeEnd ? new Date(shipInfo.scheduledDeliveryTimeEnd)
        .toLocaleString("en-US", dateOptionsWithTime) : "";
    let dispatchTime = routeInfo.dispatchTime ? new Date(routeInfo.dispatchTime)
        .toLocaleString("en-US", dateOptionsWithTime) : "";
    let releaseDate = props.data.releaseDate ? new Date(props.data.releaseDate)
        .toLocaleString("en-US", dateOptions) : "";

    const formatCustomerNotes = (customerNotes) => {
        return customerNotes.map(customerNote => ({
            dateAdded : customerNote.dateAdded ? new Date(customerNote.dateAdded).toLocaleString("en-US", dateOptionsWithTime) : "",
            customerNoteContent : customerNote.customerNoteContent,
            operationPerson : customerNote.operationPerson
        }));
    }

    async function addUserNoteToShipmentInfo(inputNote , trackingId, nodeId){
        const noteRequest = {
            "customerNoteContent" : inputNote,
            "trackingId" : trackingId,
            "nodeId" : nodeId
        };
        saveShipmentNote(noteRequest);
    }

    async function saveShipmentNote(requestBody){
        const request = {
            resourcePath: "/os/updateShipmentNotes",
            httpMethod: "post",
            processName: "oculus",
            requestBody: requestBody
        }

        const startTime = Date.now();

        try {
            const response = await getAPIGatewayDataFromParent(request);
            window.location.reload(false);
            if (response.status === 200) {
                logOperationalMetric(startTime, metricProcessName, "addUserNoteToShipmentInfo", true);
                return "Note Saved Successfully";
            } else {
                return "Error" ;
            }

        } catch (error) {
            logOperationalMetric(startTime, metricProcessName, "addUserNoteToShipmentInfo", false);
            return "" ;
        }
    }


    const addUserNotes = async (inputNote , trackingId , nodeId) =>{
        try{
            return await addUserNoteToShipmentInfo(inputNote , trackingId , nodeId);
        } catch(e){
            return null ;
        }
    }

    const onClickAddNote= () =>{
        addUserNotes(inputNote , props.data.trackingId,props.data.routeInfo.stationCode);
    }

    const sentenceCase = (str) => {
        if (!str)
            return str;
        else
            str = str.toString();

        if (str.toLowerCase() === "fdd")
            return str;

        return str.toLowerCase().replace(/_/g," ").replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    }

    return (
        <Column>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_trackingId" defaultMessage="Tracking ID"/></Text>
                <Text type="b200">{handleBlankValue(props.data.trackingId)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_status" defaultMessage="Status"/></Text>
                <Text type="b200">{handleBlankValue(handlePackageStateMapping("DETAIL", "ALL", sentenceCase(props.data.packageStatus), "DEFAULT_VIEW"))}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_reason" defaultMessage="Reason"/></Text>
                <Text type="b200">{handleBlankValue(handlePackageReasonMapping("DETAIL", "ALL", sentenceCase(props.data.reasonCode)))}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_lastUpdated" defaultMessage="Last Updated"/></Text>
                <Text type="b200">{convertLocaleTimeToFormat(lastUpdatedTime)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_linkedTrackingId" defaultMessage="Linked Tracking Id"/></Text>
                <Text type="b200">{handleBlankValue(props.data.linkedTrackingIds ? props.data.linkedTrackingIds.join(", ") : '')}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_alternateScannableId" defaultMessage="Alternate Scannable Id"/></Text>
                <Text type="b200">{handleBlankValue(props.data.alternateScannableIds ? props.data.alternateScannableIds.join(", ") : '')}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_fc" defaultMessage="FC/SC"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.warehouse)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_shipMethod" defaultMessage="Ship Method"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.shipMethod)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_shipOption" defaultMessage="Ship Option"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.shipOption)}</Text>
            </Row>
            {isINRegion() ? <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_shipType" defaultMessage="Ship Type"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.shipType)}</Text>
            </Row>:null}
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_manifestRouteCode" defaultMessage="Manifest Route Code"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.manifestRouteCode)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_shipDate" defaultMessage="Ship Date"/></Text>
                <Text type="b200">{convertLocaleTimeToFormat(shipDate)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_promisedDeliveryDate" defaultMessage="Promised Delivery Date"/></Text>
                <Text type="b200">{handleBlankValue(promisedDeliveryDate)}</Text>
            </Row>
            {isInternalPDDEnabled && (
                <Row widths={["grid-3"]} spacingInset="xsmall large">
                    <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_internalPromisedDeliveryDate" defaultMessage="Internal Promised Delivery Date"/></Text>
                    <Text type="b200">{handleBlankValue(internalPromisedDeliveryDate)}</Text>
                </Row>
            )}
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_estimatedArrivalDate" defaultMessage="Estimated Arrival Date"/></Text>
                <Text type="b200">{handleBlankValue(estimatedArrivalDate)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_scheduledDeliveryTime" defaultMessage="Scheduled Delivery Time"/></Text>
                <Text type="b200">{handleBlankValue(scheduledDeliveryTime) + handleBlankValueForScheduledDeliveryEnd(scheduledDeliveryTimeEnd)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_releaseDate" defaultMessage="RDD Dispatch Date"/></Text>
                <Text type="b200">{handleBlankValue(releaseDate)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_lockerName" defaultMessage="Locker Name"/></Text>
                <Text type="b200">{handleBlankValue(lockerName)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_serviceType" defaultMessage="Service Type"/></Text>
                <Text type="b200">{handleBlankValue(serviceType)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_itemDescription" defaultMessage="Item Description"/></Text>
                <Text type="b200">{handleBlankValue(itemDescription)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.shipmentInfo_cycle" defaultMessage="Cycle"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_assignedCycle" defaultMessage="Assigned Cycle"/></Text>
                <Text type="b200">{handleBlankValue(cycleInfo.assignedCycle)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_inductedCycle" defaultMessage="Inducted Cycle"/></Text>
                <Text type="b200">{handleBlankValue(cycleInfo.inductedCycle)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.shipmentInfo_route" defaultMessage="Route"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_station" defaultMessage="Station"/></Text>
                <Text type="b200">{handleBlankValue(routeInfo.stationCode)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_routeCode" defaultMessage="Route"/></Text>
                <Text type="b200">{handleBlankValue(routeInfo.routeCode)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_dispatchTime" defaultMessage="Dispatch Time"/></Text>
                <Text type="b200">{handleBlankValue(dispatchTime)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_provider" defaultMessage="Provider"/></Text>
                <Text type="b200">{handleBlankValue(routeInfo.provider)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_driver" defaultMessage="Driver"/></Text>
                <Text type="b200">{handleBlankValue(routeInfo.driverName)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.shipmentInfo_driverId" defaultMessage="Driver ID"/></Text>
                <Text type="b200">{handleBlankValue(routeInfo.driverCustomerId)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h300"><FormattedMessage id="search.package.shipmentInfo_notes" defaultMessage="Notes"/></Text>
            </Row>
            {props.data.updateShipmentNotesEnabled === true ? <div>
                <Row widths={["grid-3"]} spacingInset="xsmall large">
                    <Textarea resize="none" value={inputNote} onChange={setInputNote} rows={3} width="300px"/>
                </Row>
                <Row widths={["grid-3"]} spacingInset="xsmall large">
                    <Button onClick={onClickAddNote}>Add</Button>
                </Row>
            </div> : ""}


            {formatCustomerNotes(customerNotes).map(customerNote => (
                <Row widths={["grid-3"]} spacingInset="xsmall large">
                    <Column>
                      <Text type="b300">{customerNote.customerNoteContent}</Text>                
                      <Text type="b300" color="secondary"> - {customerNote.operationPerson}, {customerNote.dateAdded}</Text>
                    </Column>
                </Row>
            ))}
        </Column>
    )
 }
export default ShipmentInfo;





// WEBPACK FOOTER //
// ./src/components/detailPages/packageDetails/ShipmentInfo.js